import React from 'react';
import { TrendingDownIcon, SearchIcon, PaletteIcon, CompassIcon, ArrowRightIcon } from 'lucide-react';
import { NordenMascot } from './NordenMascot';
export function ProblemSection() {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-24 lg:py-28 bg-surface-muted overflow-hidden" data-id="element-867">
      {/* Norden with lightbulb — has the answer */}
      <div className="absolute -bottom-4 right-4 lg:right-8 opacity-80 pointer-events-none hidden xl:block" data-id="element-868">
        <NordenMascot variant="lightbulb" size="md" data-id="element-869" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-870">
        <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 text-center mb-4" data-id="element-871">
          Herkenbaar?
        </h2>
        <p className="text-lg text-slate-600 text-center max-w-2xl mx-auto mb-12 lg:mb-16" data-id="element-872">
          Veel accountants en financieel adviseurs lopen tegen dezelfde
          problemen aan als ze online willen groeien.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-873">
          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-874">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-875">
              <TrendingDownIcon className="w-6 h-6 text-accent" data-id="element-876" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-877">
              Je via-via netwerk raakt langzaam uitgeput
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-878">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-879">
              <SearchIcon className="w-6 h-6 text-accent" data-id="element-880" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-881">
              Google Ads zijn te duur en leveren slechte leads op
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-882">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-883">
              <PaletteIcon className="w-6 h-6 text-accent" data-id="element-884" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-885">
              Slechte ervaringen met vage marketingbureaus
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-886">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-887">
              <CompassIcon className="w-6 h-6 text-accent" data-id="element-888" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-889">
              Je bent te druk met klantwerk om SEO uit te zoeken
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 text-center" data-id="element-890">
          <span className="text-navy-700 font-medium" data-id="element-891">
            Herken je dit? Wij helpen je verder.
          </span>
          <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-semibold px-6 py-3 rounded-button shadow-soft hover:shadow-medium transition-all duration-200" data-id="element-892">
            Neem contact op
            <ArrowRightIcon className="w-4 h-4" data-id="element-893" />
          </a>
        </div>
      </div>
    </section>;
}